
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useContext, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../../store/rootReducer";

import VersionControl from "../../VersionControl/VersionControl";

import "../PanelContent.css";
import SearchResults from "../../SearchResults/SearchResults";
import { LeftPanelTabs } from "../../../constants/Panels";
import FeatureViewer from "../../FeatureViewer/FeatureViewer";
import { AppContext } from "../../../Context";
import { setLeftPanelOpen } from "../../../store/appSlice";

const LeftPanelContent = () => {

    const dispatch = useDispatch();

    const [activeIndex, setActiveIndex] = useState<number>(-1);

    const leftPanelActiveTab = useSelector((state: StoreState) => state.app.leftPanelActiveTab);

    const appContext = useContext(AppContext);
    const viewedFeature = appContext?.shownFeature.value;

    const [renderedTabs, setRenderedTabs] = useState<{ [key: number]: boolean }>({});
    const handleTabSelect = (index: number) => {
        setActiveIndex(index);
        setRenderedTabs((prev) => ({ ...prev, [index]: true }));
    }

    useEffect(() => {
        switch (leftPanelActiveTab) {
            case LeftPanelTabs.UNDEFINED:
                setActiveIndex(-1);
                break;
            case LeftPanelTabs.VERSIONS:
                setActiveIndex(0);
                break;
            case LeftPanelTabs.CATALOG:
            case LeftPanelTabs.SEARCH:
                setActiveIndex(1);
                break;
            case LeftPanelTabs.VIEWER:
                setActiveIndex(2);
                break;
        }
    }, [leftPanelActiveTab]);

    useEffect(() => {
        if (activeIndex === -1) {
            dispatch(setLeftPanelOpen(false));
        } else {
            dispatch(setLeftPanelOpen(true));
        }
    }, [activeIndex]);

    return (
        <div className="panel-content">
            <Tabs className={`w-100 h-100 flex-col`} selectedIndex={activeIndex} disabledTabClassName="disabled" selectedTabClassName="selected" onSelect={handleTabSelect}>
                <TabList className={`panel-content-tab-list hidden`}>
                    <Tab className={`panel-content-tab-button`}>
                        Versjoner
                    </Tab>
                    <Tab className={`panel-content-tab-button`}>
                        Katalog
                    </Tab>
                    <Tab disabled={viewedFeature === null} className={`panel-content-tab-button`}>
                        Objekt
                    </Tab>
                </TabList>
                <TabPanel selectedClassName="selected" className={`panel-content-tab-panel`} forceRender={true}>{/* Version control handles the reading of version from Url and setting correctly in map */}
                    <VersionControl />
                </TabPanel>
                <TabPanel selectedClassName="selected" className={`panel-content-tab-panel`} forceRender={true}> {/* Search results handles the search and catalog display - Result empty when clicking in the map if not loaded */}
                    <SearchResults />
                </TabPanel>
                <TabPanel selectedClassName="selected" className={`panel-content-tab-panel`} forceRender={renderedTabs[2]}>
                    <FeatureViewer />
                </TabPanel>
            </Tabs>
        </div>
    );
}

export default LeftPanelContent;